import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { EntityMatch, registerLexicalTextEntity } from "@lexical/text";
import { useEffect, useMemo, useRef } from "react";
import { mergeRegister } from '@lexical/utils';
import { VariableNode } from "../nodes/VariableNode";

export function matchVariableKeyword(text: string): EntityMatch | null
{
    const regex = /{[^}]+}/g;
    const match = regex.exec(text);
    // eslint-disable-next-line no-undefined
    if (match && match.index !== undefined)
    {
        return { start: match.index, end: match.index + match[0].length };
    }
    return null;
}

export function VariablesPlugin({ variables }: { variables: string[] })
{
    const pattern = useMemo(() =>
    {
        if (variables) { return new RegExp(`{(${variables.map(variable => variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})}`); }
    },
    [variables]);
    const [editor] = useLexicalComposerContext();
    useEffect(() =>
    {
        if (!editor.hasNodes([VariableNode]))
        {
            throw new Error('HashtagPlugin: HashtagNode not registered on editor');
        }
    },
    [editor]);
    useEffect(() =>
    {
        const register = registerLexicalTextEntity<VariableNode>
        (
            editor,
            matchVariableKeyword,
            VariableNode,
            node =>
            {
                return new VariableNode(node.getTextContent(), pattern);
            }
        );
        return mergeRegister(...register);
    },
    [editor]);
    return null;
}